import React from 'react';
import '../SiteManagement.css';

const ChatGroupPageWrapper = ({ children }) => (
  <div className="site-management-container community-route">
    <div className="site-management-content community-route">
      <div className="community-onboarding-page">{children}</div>
    </div>
  </div>
);

export default ChatGroupPageWrapper;
